import { utilsConstants } from '../constants';
import { utilsServices } from '../services';

export const countryAction = {
    getCountry,
};

function getCountry() {
    return (dispatch) => {
        dispatch(request());
        return utilsServices
            .country()
            .then((response) => {
                let obj = [];
                response.data.data.forEach((country) => {
                    obj.push({ value: country.id, label: country.name });
                });
                dispatch(success(obj));
            })
            .catch((error) => {
                // console.log(error);
                dispatch(failure(error));
            });
    };

    function request(user) {
        return { type: utilsConstants.REQUEST_COUNTRY, user };
    }
    function success(country) {
        return { type: utilsConstants.RECIEVE_COUNTRY, country };
    }
    function failure(error) {
        return { type: utilsConstants.ERROR_COUNTRY, error };
    }
}
